import { API_BASE_URL } from "../../Api/apiconnector";

// const API_BASE_URL = 'http://localhost:8000/api';

// ✅ helper: get logged in user group
const getUserGroup = () => {
  try {
    return JSON.parse(localStorage.getItem("user"))?.user?.group || null;
  } catch {
    return null;
  }
};

const isCorporate = () => getUserGroup() === "corporatecoordinator";

const CoordinatorHandler = {
  // Get coordinators profile data
  // getCoordinators: async () => {
  //   try {
  //     const response = await fetch(`${API_BASE_URL}/coordinators/`, {
  //       method: "GET",
  //       credentials: "include", // ✅ Include cookies for authentication
  //       headers: {
  //         "Content-Type": "application/json",
  //       },
  //     });

  //     if (!response.ok) {
  //       throw new Error(`HTTP error! status: ${response.status}`);
  //     }
  //     const data = await response.json();
  //     return data.result; // ✅ Extract the coordinator object from the 'result' key
  //   } catch (error) {
  //     console.error("Error fetching coordinators:", error);
  //     throw error;
  //   }
  // },

  getCoordinators: async () => {
    if (isCorporate()) return null; // skip
    try {
      const response = await fetch(`${API_BASE_URL}/coordinators/`, {
        credentials: "include",
      });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      return data.result;
    } catch (error) {
      console.error("Error fetching coordinators:", error);
      throw error;
    }
  },

  sendToU4rad: async (dicomIds) => {
    try {
      const response = await fetch(`${API_BASE_URL}/corporatecoordinator/send-to-u4rad/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRFToken": CoordinatorHandler.getCsrfToken(), // ✅ FIX
        },
        credentials: "include",
        body: JSON.stringify({
          dicom_ids: dicomIds,
        }),
      });
  
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
  
      return await response.json();
    } catch (error) {
      console.error("Error sending to U4RAD:", error);
      throw error;
    }
  },

  // Get all patient data with TAT counters
  getTatCounters: async (cursor = null) => {
    try {
      const params = new URLSearchParams();
      params.append("limit", "400"); // You can adjust this limit
      if (cursor) {
        params.append("cursor", cursor);
      }
      const response = await fetch(
        `${API_BASE_URL}/fetch-tat-counters/?${params.toString()}`,
        {
          method: "GET",
          credentials: "include",
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      console.log("TAT Counters Data:", data); // Debug log
      return data;
    } catch (error) {
      console.error("Error fetching TAT counters:", error);
      throw error;
    }
  },

  // getCaseCounts: async () => {
  //   try {
  //     const response = await fetch(`${API_BASE_URL}/corporatecoordinator/corporate_case_counts/`);
  //     if (!response.ok) {
  //       throw new Error(`HTTP error! status: ${response.status}`);
  //     }
  //     const data = await response.json();
  //     return data;
  //   } catch (error) {
  //     console.error("Error fetching case counts:", error);
  //     throw error;
  //   }
  // },

  getCaseCounts: async () => {
    const url = isCorporate()
      ? `${API_BASE_URL}/corporatecoordinator/corporate_case_counts/`
      : `${API_BASE_URL}/case_counts/`;
  
    const response = await fetch(url, {
      credentials: "include",   // ⭐ REQUIRED
    });
  
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
  
    return await response.json();
  },

  // Update patient status
  updatePatientStatus: async (patientId, statusData) => {
    try {
      const response = await fetch(
        `${API_BASE_URL}/patients/${patientId}/status`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(statusData),
        }
      );
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      console.error("Error updating patient status:", error);
      throw error;
    }
  },

  // Assign radiologist to patient
  // assignRadiologist: async (dicomId, radiologistUserId) => {
  //   try {
  //     const response = await fetch(`${API_BASE_URL}/corporatecoordinator/assign-radiologist/`, {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json",
  //       },
  //       body: JSON.stringify({
  //         dicom_id: dicomId,
  //         radiologist_user_id: radiologistUserId,
  //       }),
  //     });
  //     if (!response.ok) {
  //       throw new Error(`HTTP error! status: ${response.status}`);
  //     }
  //     return await response.json();
  //   } catch (error) {
  //     console.error("Error assigning radiologist:", error);
  //     throw error;
  //   }
  // },

  assignRadiologist: async (dicomId, radiologistUserId) => {
    try {
      const response = await fetch(
        `${API_BASE_URL}/corporatecoordinator/assign-radiologist/`,
        {
          method: "POST",
          credentials: "include",   // ✅🔥 THIS FIXES EVERYTHING
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            dicom_id: dicomId,
            radiologist_user_id: Number(radiologistUserId), // ✅ also fix type
          }),
        }
      );
  
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
  
      return await response.json();
    } catch (error) {
      console.error("Error assigning radiologist:", error);
      throw error;
    }
  },

  // Get radiologists list
  // getRadiologists: async () => {
  //   try {
  //     const response = await fetch(`${API_BASE_URL}/radiologists/`);
  //     if (!response.ok) {
  //       throw new Error(`HTTP error! status: ${response.status}`);
  //     }
  //     const data = await response.json();
  //     console.log("Radiologists Data:", data); // Debug log
  //     return data;
  //   } catch (error) {
  //     console.error("Error fetching radiologists:", error);
  //     throw error;
  //   }
  // },

  getRadiologists: async () => {
    try {
      const url = isCorporate()
        ? `${API_BASE_URL}/corporatecoordinator/radiologists/`
        : `${API_BASE_URL}/radiologists/`;
      const response = await fetch(url, {
        credentials: "include",
      });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      console.error("Error fetching radiologists:", error);
      throw error;
    }
  },

  replaceRadiologist: async (dicomId, radiologistUserId) => {
    try {
      const response = await fetch(`${API_BASE_URL}/replace-radiologist/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          dicom_id: dicomId,
          radiologist_user_id: Number(radiologistUserId),
        }),
      });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      console.error("Error replacing radiologist:", error);
      throw error;
    }
  },

  getBodyParts: async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/body-parts/`);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error fetching body parts:", error);
      throw error;
    }
  },

  // 🔹 Update patient details (with history file upload support)
  updatePatient: async (patientId, newData, historyFiles = null) => {
    try {
      const payload = {
        ...newData,
      };

      if (historyFiles && historyFiles.length > 0) {
        // Only names, unless you plan to send base64 content
        payload.history_files = historyFiles.map((file) => file.name);
      }

      const response = await fetch(
        `${API_BASE_URL}/update-dicom/${patientId}/`,
        {
          method: "PUT", // full update
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error("Error updating patient:", error);
      throw error;
    }
  },

  uploadHistoryFiles: async (dicomId, historyFiles) => {
    try {
      if (!dicomId) {
        throw new Error("dicomId is required for uploading history files");
      }

      const formData = new FormData();
      formData.append("dicom_data", dicomId);

      if (Array.isArray(historyFiles) && historyFiles.length > 0) {
        historyFiles.forEach((file) => {
          if (file) formData.append("history_file", file);
        });
      } else if (historyFiles) {
        formData.append("history_file", historyFiles);
      }

      const response = await fetch(
        `${API_BASE_URL}/upload-historyfile/${dicomId}/`,
        {
          method: "POST",
          body: formData,
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error("Error uploading history files:", error);
      throw error;
    }
  },

  // searchPatients: async (searchTerm) => {
  //   if (!searchTerm) {
  //     return [];
  //   }

  //   // Check patterns
  //   const isAlphabetic = /^[A-Za-z]+$/.test(searchTerm); // Only letters
  //   const isAlphaNumeric = /^[A-Za-z0-9]+$/.test(searchTerm); // Letters +/or numbers

  //   // Build URL based on condition
  //   let url = "";

  //   if (isAlphabetic) {
  //     // Example: 'Shyam' → name search
  //     url = `${API_BASE_URL}/search_patient/?patient_name=${searchTerm}`;
  //   } else if (isAlphaNumeric) {
  //     // Example: 'P-00123' OR '123' → ID search
  //     url = `${API_BASE_URL}/search_patient/?patient_id=${searchTerm}`;
  //   } else {
  //     // If contains special characters (optional)
  //     return [];
  //   }

  //   try {
  //     const response = await fetch(url);
  //     if (!response.ok) {
  //       throw new Error(`HTTP error! status: ${response.status}`);
  //     }

  //     const data = await response.json();
  //     return data.results || [];
  //   } catch (error) {
  //     console.error("Error searching patients:", error);
  //     throw error;
  //   }
  // },
  
  
  // searchPatients: async (searchTerm) => {
  //   if (!searchTerm) {
  //     return [];
  //   }

  //   // Check patterns
  //   const isAlphabetic = /^[A-Za-z ]+$/.test(searchTerm); // Allow letters + spaces
  //   const isAlphaNumeric = /^[A-Za-z0-9]+$/.test(searchTerm); // Letters +/or numbers
  //   const hasNumbers = /\d/.test(searchTerm);
  //   // Build URL based on condition
  //   let url = "";

  //   if (isAlphabetic) {
  //     // Example: 'Shyam' or 'Roop Chand' → name search
  //     url = `${API_BASE_URL}/search_patient/?patient_name=${searchTerm}`;
  //   } else if (isAlphaNumeric) {
  //     // Example: 'P00123' OR '123' → ID search
  //     url = `${API_BASE_URL}/search_patient/?patient_id=${searchTerm}`;
  //   } else if (hasNumbers) {
  //    // Contains numbers - search by ID (allows hyphens, numbers, letters)
  //     url = `${API_BASE_URL}/search_patient/?patient_id=${encodeURIComponent(searchTerm)}`;
  //   } else {
  //     // If contains special characters
  //     return [];
  //   }

  //   try {
  //     const response = await fetch(url);
  //     if (!response.ok) {
  //       throw new Error(`HTTP error! status: ${response.status}`);
  //     }

  //     const data = await response.json();
  //     return data.results || [];
  //   } catch (error) {
  //     console.error("Error searching patients:", error);
  //     throw error;
  //   }
  // },

  searchPatients: async (searchTerm) => {
  if (!searchTerm?.trim()) {
    return [];
  }

  const trimmedTerm = searchTerm.trim();

  // Check patterns
  const isAlphabetic = /^[A-Za-z ]+$/.test(trimmedTerm); // Letters + spaces
  const isAlphaNumeric = /^[A-Za-z0-9]+$/.test(trimmedTerm); // Letters + numbers
  const hasNumbers = /\d/.test(trimmedTerm);

  // Build URL based on condition
  let url = "";

  if (isAlphabetic) {
    // Name search
    url = `${API_BASE_URL}/search_patient/?patient_name=${encodeURIComponent(trimmedTerm)}`;
  } else if (isAlphaNumeric || hasNumbers) {
    // ID search
    url = `${API_BASE_URL}/search_patient/?patient_id=${encodeURIComponent(trimmedTerm)}`;
  } else {
    // Contains special characters → skip
    return [];
  }

  try {
    const response = await fetch(url, {
      credentials: 'include', // <-- send session cookies to authenticate user
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return Array.isArray(data.results) ? data.results : [];
  } catch (error) {
    console.error("Error searching patients:", error);
    return [];
  }
},

  

   searchReport: async (searchTerm) => {
    if (!searchTerm) {
      return [];
    }

    // Check patterns
    const isAlphabetic = /^[A-Za-z ]+$/.test(searchTerm); // Allow letters + spaces
    const isAlphaNumeric = /^[A-Za-z0-9]+$/.test(searchTerm); // Letters +/or numbers
    const hasNumbers = /\d/.test(searchTerm);
    // Build URL based on condition
    let url = "";

    if (isAlphabetic) {
      // Example: 'Shyam' or 'Roop Chand' → name search
      url = `${API_BASE_URL}/search_report/?patient_name=${searchTerm}`;
    } else if (isAlphaNumeric) {
      // Example: 'P00123' OR '123' → ID search
      url = `${API_BASE_URL}/search_report/?patient_id=${searchTerm}`;
    }else if (hasNumbers) {
    // Contains numbers - search by ID (allows hyphens, numbers, letters)
      url = `${API_BASE_URL}/search_report/?patient_id=${encodeURIComponent(searchTerm)}`;
    } else {
      // If contains special characters
      return [];
    }

    try {
      const response = await fetch(url, {
        method: "GET",
        credentials: "include", // 🔥 ONLY REQUIRED CHANGE
      });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data.results || [];
    } catch (error) {
      console.error("Error searching patients:", error);
      throw error;
    }
  },
  

  fetchCompletedTatCounters: async (limit = 200, cursor = null) => {
    try {
      const url = new URL(`${API_BASE_URL}/fetch-completed-tat-counters/`);
      url.searchParams.append("limit", limit);
      if (cursor) {
        url.searchParams.append("cursor", cursor);
      }
      // Log the full request URL to help debug when the API is (or isn't) being called
      console.log("Fetching completed TAT counters from:", url.toString());

      // Include credentials (cookies) in case the backend requires session auth
      const response = await fetch(url, { credentials: "include" });
      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }
      return await response.json();
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  },

  // Send PDF report via email
  // POST /email-pdf-raw/<patient_id>/
  // Payload: { email, name, pdf_url }
  sendEmailPdfRaw: async (patientId, payload) => {
    try {
      const response = await fetch(
        `${API_BASE_URL}/email-pdf-raw/${encodeURIComponent(patientId)}/`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
          credentials: "include",
        }
      );
      if (!response.ok) {
        throw new Error("Failed to send email");
      }
      return { success: true, data: await response.json() };
    } catch (error) {
      console.error("Email API Error:", error);
      return { success: false, error: error.message };
    }
  },

  // Send PDF report via WhatsApp
  // POST /send-whatsapp/
  // Payload: { whatsapp_number, patient_name, pdf_url, patient_id }
  sendWhatsapp: async (payload) => {
    try {
      const response = await fetch(`${API_BASE_URL}/send-whatsapp/`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
        credentials: "include",
      });
      if (!response.ok) {
        throw new Error("Failed to send WhatsApp");
      }
      return { success: true, data: await response.json() };
    } catch (error) {
      console.error("WhatsApp API Error:", error);
      return { success: false, error: error.message };
    }
  },

  getPresignedUrl: async (fileKey) => {
    try {
      const response = await fetch(`${API_BASE_URL}/get-file-url/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify({ key: fileKey }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return { success: true, url: data.url };
    } catch (error) {
      console.error("Error fetching presigned URL:", error);
      return { success: false, error: error.message };
    }
  },

  getPresignedUrlComplete: async (fileKey) => {
    try {
      const response = await fetch(`${API_BASE_URL}/get-file-url-complete/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify({ key: fileKey }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return { success: true, url: data.url };
    } catch (error) {
      console.error("Error fetching presigned URL:", error);
      return { success: false, error: error.message };
    }
  },

  // Download a PDF report from a URL
  downloadReport: async (fileKey, fileName = "report.pdf") => {
    try {
      // First, get the presigned URL
      const urlResult = await CoordinatorHandler.getPresignedUrlComplete(
        fileKey
      );

      if (!urlResult.success || !urlResult.url) {
        throw new Error("Failed to get download URL");
      }

      // Download the file using the presigned URL
      const response = await fetch(urlResult.url, {
        method: "GET",
        headers: { "Content-Type": "application/pdf" },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);

      return { success: true };
    } catch (error) {
      console.error("Download failed:", error);
      return { success: false, error: error.message };
    }
  },

  getFaqs: async (group) => {
    try {
      // Include credentials so session-based auth (cookies) is sent
      const response = await fetch(`${API_BASE_URL}/faqs/?group=${group}`, {
        credentials: "include",
      });
      const data = await response.json().catch(() => null);

      if (!response.ok) {
        // Return a consistent shape similar to ApiHandler.makeRequest
        return { success: false, data, status: response.status };
      }

      return { success: true, data, status: response.status };
    } catch (error) {
      console.error("Error fetching FAQs:", error);
      return { success: false, error: error.message };
    }
  },

  // Get patients by date with optional cursor-based pagination
  getPatientsByDate: async (start_date, end_date) => {
    try {
      const params = new URLSearchParams();
      params.append("start_date", start_date);
      params.append("end_date", end_date);
      const response = await fetch(
        `${API_BASE_URL}/search_patient/?${params.toString()}`,
        {
          method: "GET",
          credentials: "include", // include cookies if session-based auth
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      console.log("Patients Data:", data); // Debug log
      return data;
    } catch (error) {
      console.error("Error fetching patients by date:", error);
      throw error;
    }
  },

  // Upload patient note for multiple patients
  uploadPatientNote: async (ids, note) => {
    try {
      const payload = {
        id: ids, // array of patient IDs
        note: note, // note string
      };

      const response = await fetch(`${API_BASE_URL}/upload-note/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include", // if session-based auth
        body: JSON.stringify(payload),
      });

      const data = await response.json().catch(() => null);

      if (!response.ok) {
        return { success: false, data, status: response.status };
      }

      return { success: true, data, status: response.status };
    } catch (error) {
      console.error("Error uploading patient note:", error);
      return { success: false, error: error.message };
    }
  },

  // Get CSRF token helper method
  getCsrfToken: () => {
    const cookieValue = document.cookie
      .split('; ')
      .find(row => row.startsWith('csrftoken='))
      ?.split('=')[1];
    return cookieValue || '';
  },

  // Bulk update notes for multiple patients
  bulkUpdateNotes: async (patientIds, notesText) => {
    try {
      const response = await fetch(`${API_BASE_URL}/bulk-update-notes/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRFToken': CoordinatorHandler.getCsrfToken(),
        },
        credentials: 'include',
        body: JSON.stringify({
          patient_ids: patientIds,
          notes: notesText
        }),
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      return await response.json();
    } catch (error) {
      console.error('Error in bulkUpdateNotes:', error);
      throw error;
    }
  },

  // Assign corporate coordinator (bulk)
  assignCorporateCoordinator: async (dicomIds, corporateUserId) => {
    try {
      const response = await fetch(`${API_BASE_URL}/assign-corporatecoordinator/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify({
          dicom_ids: dicomIds,
          corporatecoordinator_user_id: corporateUserId,
        }),
      });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      console.error("Error assigning corporate coordinator:", error);
      throw error;
    }
  },

  // Replace corporate coordinator
  replaceCorporateCoordinator: async (dicomIds, corporateUserId) => {
    try {
      const response = await fetch(`${API_BASE_URL}/replace-corporatecoordinator/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify({
          dicom_ids: dicomIds,
          corporate_user_id: corporateUserId,
        }),
      });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      console.error("Error replacing corporate coordinator:", error);
      throw error;
    }
  },

  // getCorporateCoordinators: async () => {
  //   try {
  //     const response = await fetch(`${API_BASE_URL}/corporatecoordinators/`, {
  //       credentials: "include",
  //     });
  //     if (!response.ok) {
  //       throw new Error("Failed to fetch corporate coordinators");
  //     }
  //     return await response.json();
  //   } catch (error) {
  //     console.error("Error fetching corporate coordinators:", error);
  //     return [];
  //   }
  // },

  getCorporateCoordinators: async () => {
    if (isCorporate()) return []; // skip
    try {
      const response = await fetch(`${API_BASE_URL}/corporatecoordinators/`, {
        credentials: "include",
      });
      if (!response.ok) {
        throw new Error("Failed to fetch corporate coordinators");
      }
      return await response.json();
    } catch (error) {
      console.error("Error fetching corporate coordinators:", error);
      return [];
    }
  },

};

export default CoordinatorHandler;